import { defineStore } from 'pinia/dist/pinia'
import { loadYearChartData } from '@/service/Versorgungsatlas'
import { fillDataArraysYear } from '@/service/Versorgungsatlas'

export const useEvaluationYearStore = defineStore('evaluationYearList', {
    state: () => ({
        evaluationYearList: [],
        yearListValuesMale: [],
        yearListValuesFemale: [],
        yearListValuesTotal: [],
        yearListLabels: [],
        latestYear: 0,
        firstYear: 0,
        absoluteLatestYear: 0,
        absoluteDeltaYear: 0,
        percentageDeltaYear: 0,
        ratioMaleFemaleYear: 0,
        auswid: 0,
        ausprid: 0,
    }),
    getters: {
        getEvaluationById: (state) => {
            return (auswid) => state.evaluationYearList.find((evaluation) => parseInt(evaluation.auswid) === parseInt(auswid))
        },
        getLabelsXAxis() {
            return this.yearListLabels
        },
        getMaleData() {
            return this.yearListValuesMale
        },
        getFemaleData() {
            return this.yearListValuesFemale
        },
        getTotalData() {
            return this.yearListValuesTotal
        },
        getFirstYear() {
            return this.firstYear
        },
        getAbsoluteLatestYear() {
            return this.absoluteLatestYear
        },
        getAbsoluteDeltaYear() {
            const formattedDelta = this.absoluteDeltaYear.toLocaleString('de-DE', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                useGrouping: true,
                signDisplay: 'exceptZero' // add the signDisplay option
            });
            return (this.absoluteDeltaYear > 0 ? formattedDelta : formattedDelta);
        },

        getPercentageDeltaYear() {
            return (this.absoluteDeltaYear > 0 ? '+'+this.percentageDeltaYear : this.percentageDeltaYear)
        },
        getRatioMaleFemale() {
            return this.ratioMaleFemaleYear
        },
        getLatestYear: (state) => {
            return (auswid, ausprid) => state.update(auswid, ausprid)
        }
    },
    actions: {
        update(auswid, ausprid) {
            let newLoadAuswid = (this.auswid != auswid)
            let newLoadAusprid = (this.ausprid != ausprid && ausprid != 0);

            if (newLoadAuswid) {
                this.loadYearChartData(auswid, ausprid,true);
            } else if (newLoadAusprid) {
                this.updateStates(auswid, ausprid);
            }

            return this.latestYear;
        },
        updateStates(auswid, ausprid) {
            //this.evaluationAgeList enthält user_ziva_werte
            // zu einer auswid mit ausprids zwischen 1 und 10 entsprechend den Altersgruppen
            // für alle Männer und Frauen
            // für mehrere Jahre
            let result = fillDataArraysYear(this.evaluationYearList, ausprid);

            this.latestYear = result[0]['latestYear'];
            this.firstYear = result[1]['firstYear'];
            this.yearListLabels = result[2]['yearListLabels'];
            this.yearListValuesMale = result[3]['yearListValuesMale'];
            this.yearListValuesFemale = result[4]['yearListValuesFemale'];
            this.yearListValuesTotal = result[5]['yearListValuesTotal'];
            this.absoluteLatestYear = result[6]['absoluteLatestYear'];
            this.absoluteDeltaYear = result[7]['absoluteDeltaYear'];
            this.percentageDeltaYear = result[8]['percentageDeltaYear'];
            this.ratioMaleFemaleYear = result[9]['ratioMaleFemaleYear'];
            this.auswid = auswid;
            this.ausprid = ausprid;
        },
        async loadYearChartData(auswid, ausprid, force = false) {
            if ((this.evaluationYearList?.length === 0) || force === true) {
                const resultSetAge = await loadYearChartData(auswid)
                this.evaluationYearList = resultSetAge.data ?? []
            }

            this.updateStates(auswid, ausprid);
        },
    },
})